module.exports = __webpack_public_path__ + "img/co_banner.436ef657.png";